export default __webpack_public_path__ + "static/media/AmrutaMarathe.0f895654.png";